import React, { MouseEvent, useState } from 'react';
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader, Price } from 'fronton-react';
import cn from 'clsx';
import { Button } from 'common/components/button';
import { Typography } from 'common/components/typography';
import { getImageSrc } from 'common/components/picture';
import { fullWidthMobileButton } from 'common/styles/common';
import { VariantAxisPoint, VariantAxisProduct, VariantsAxisModel } from 'modules/collections';
import { createElementKey } from 'utils';
import { AxisPoints } from '../axis-points-new';
import {
  drawerAxisPoints,
  drawerAxisPointsButton,
  drawerAxisPointsPreview,
  drawerAxisPointsPreviewImage,
  drawerAxisPointsPreviewInfo,
} from './drawer-axis-points-styles';

type DrawerAxisPointsProps = {
  activePoint: VariantAxisProduct;
  axisPoints: VariantsAxisModel[];
  landingName: string;
  show: boolean;
  onClose: TFunction;
}

export const DrawerAxisPoints: React.FC<DrawerAxisPointsProps> = ({ activePoint, axisPoints, landingName, onClose, show }) => {
  const [selectedPoint, setSelectedPoint] = useState(activePoint);

  const handlePointClick = (_: MouseEvent, point: VariantAxisPoint, axis: string) => {
    const productUrlParts = selectedPoint.productUrl.split('?');
    let productUrl = point.productUrl;

    let updatedPoint = {
      ...selectedPoint,
      productUrl,
      axesValues: selectedPoint.axesValues.map(v =>
        (v.id === axis)
          ? {
            id: v.id,
            axis: point.label,
          }
          : v
      )
    };

    if (axis === '10001') {
      productUrlParts[0] = point.productUrl;

      updatedPoint = {
        ...updatedPoint,
        mediaPhoto: point.mediaPhoto,
        displayedName: point.displayedName,
        price: point.price,
        productUrl: productUrlParts.join('?'),
        label: point.label,
        name: point.name,
      }
    }

    if (axis === '10002') {
      productUrlParts[1] = point.productUrl;
      updatedPoint = {
        ...updatedPoint,
        productUrl: productUrlParts.join(''),
        label: point.label,
        name: point.name,
      }
    }

    setSelectedPoint(updatedPoint);
  }

  const handleSelectBtnClick = (e: MouseEvent) => {
    if (activePoint.productUrl === selectedPoint.productUrl) {
      e.preventDefault();
      e.stopPropagation();
    }

    onClose();
  }

  return (
    <Drawer className={drawerAxisPoints} size="m" show={show} onClose={onClose} overlayClose>
      <DrawerHeader title='' onClickBack={onClose} />

      <DrawerContent>
        <div className={drawerAxisPointsPreview}>
          <img
            alt={selectedPoint.displayedName}
            className={drawerAxisPointsPreviewImage}
            src={getImageSrc(
              `${landingName}${selectedPoint.mediaPhoto[0]}`,
              {
                width: 108,
                height: 108,
                objectFit: 'fill',
              },
              true
            )}
          />
          <div className={drawerAxisPointsPreviewInfo}>
            <Typography size="body_long" variant="s">{selectedPoint.displayedName}</Typography>
            <Price
              prefixText="от"
              units="₽"
              value={selectedPoint.price.price}
              variant="accent"
            />
          </div>
        </div>

        {axisPoints.map(({ axisMeta, pointsOnAxis }, index) => (
          <AxisPoints
            activePoint={selectedPoint}
            axisMeta={axisMeta}
            axisPoints={pointsOnAxis}
            landingName={landingName}
            key={createElementKey('axis-points', index)}
            onPointClick={handlePointClick}
            experimentCookie='A'
          />
        ))}

      </DrawerContent>

      <DrawerFooter>
        <Button
          className={cn(fullWidthMobileButton, drawerAxisPointsButton)}
          href={selectedPoint.productUrl}
          onClick={handleSelectBtnClick}
          title={selectedPoint.displayedName}
          wide
        >
          Выбрать
        </Button>
      </DrawerFooter>
    </Drawer>
  );
}
